import classNames from 'classnames';
import { useSgBsTheme } from 'hooks/useSgBsTheme';
import { forwardRef, MouseEvent, useCallback } from 'react';
import { useIntl } from 'react-intl';

type MoreDetailsButtonsProps = Readonly<{ onClick: () => void }>;

export const MoreDetailsButton = forwardRef<HTMLAnchorElement, MoreDetailsButtonsProps>(({ onClick }, ref) => {
  const { formatMessage } = useIntl();
  const theme = useSgBsTheme();
  const onButtonClick = useCallback(
    (e: MouseEvent<HTMLAnchorElement>) => {
      e.stopPropagation();
      onClick();
    },
    [onClick],
  );

  return (
    <a
      ref={ref}
      className={classNames('text-link fw-semibold', {
        'text-white': theme === 'light',
        'text-black': theme === 'dark',
      })}
      onClick={onButtonClick}
    >
      {formatMessage({ id: 'dashboard.rejected.details' })}
    </a>
  );
});

MoreDetailsButton.displayName = 'MoreDetailsButton';
